import React from 'react'
import classnames from 'classnames'

interface ModalMessageIconProps {
  className?: string
}

const ModalMessageWarningIcon: React.FC<ModalMessageIconProps> = ({
  className = '',
}) => {
  return (
    <svg
      className={classnames('icon-modal-message-warning', {
        [className]: !!className,
      })}
      xmlns="http://www.w3.org/2000/svg"
      width="71"
      height="70"
      viewBox="0 0 71 70"
      fill="none"
    >
      <circle cx="35" cy="35" r="35" fill="#FCD669" fillOpacity="0.6" />
      <path
        d="M49.025 47.712H20.9749C19.6977 47.7074 18.4741 47.1979 17.571 46.2948C16.6678 45.3917 16.1584 44.1681 16.1538 42.8909V25.3596C16.1584 24.0823 16.6678 22.8588 17.571 21.9556C18.4741 21.0525 19.6977 20.5431 20.9749 20.5385H49.025C50.3022 20.5431 51.5258 21.0525 52.4289 21.9556C53.3321 22.8588 53.8415 24.0823 53.8461 25.3596V42.8909C53.8415 44.1681 53.3321 45.3917 52.4289 46.2948C51.5258 47.1979 50.3022 47.7074 49.025 47.712ZM20.9749 23.1681C20.3937 23.1681 19.8363 23.399 19.4254 23.81C19.0144 24.221 18.7835 24.7784 18.7835 25.3596V42.8909C18.7835 43.4721 19.0144 44.0295 19.4254 44.4404C19.8363 44.8514 20.3937 45.0823 20.9749 45.0823H49.025C49.6062 45.0823 50.1636 44.8514 50.5746 44.4404C50.9855 44.0295 51.2164 43.4721 51.2164 42.8909V25.3596C51.2164 24.7784 50.9855 24.221 50.5746 23.81C50.1636 23.399 49.6062 23.1681 49.025 23.1681H20.9749Z"
        fill="#C99100"
      />
      <path
        d="M34.9999 36.4919C33.9826 36.4919 32.9838 36.2195 32.1073 35.703L16.8025 26.6043C16.5165 26.4261 16.3087 26.1461 16.2209 25.8208C16.133 25.4955 16.1717 25.1491 16.3291 24.8511C16.5041 24.5615 16.7854 24.3518 17.1129 24.2666C17.4405 24.1814 17.7883 24.2276 18.0822 24.3953L33.4046 33.4765C33.8693 33.76 34.4031 33.9099 34.9474 33.9099C35.4916 33.9099 36.0254 33.76 36.4901 33.4765L51.8125 24.3953C52.1064 24.2276 52.4542 24.1814 52.7818 24.2666C53.1093 24.3518 53.3906 24.5615 53.5656 24.8511C53.723 25.1491 53.7617 25.4955 53.6738 25.8208C53.586 26.1461 53.3782 26.4261 53.0923 26.6043L37.8926 35.703C37.0161 36.2195 36.0173 36.4919 34.9999 36.4919Z"
        fill="#C99100"
      />
      <path
        d="M69.7826 49.3038L62.2853 35.5219C61.0808 33.494 58.1444 33.4913 56.9382 35.5219L49.4413 49.3038C48.21 51.376 49.7008 54 52.1143 54H67.1091C69.5205 54 71.014 51.3781 69.7826 49.3038ZM59.6118 51.5129C58.9262 51.5129 58.3682 50.9548 58.3682 50.2693C58.3682 49.5838 58.9262 49.0257 59.6118 49.0257C60.2973 49.0257 60.8554 49.5838 60.8554 50.2693C60.8554 50.9548 60.2973 51.5129 59.6118 51.5129ZM60.8554 46.5386C60.8554 47.2241 60.2973 47.7822 59.6118 47.7822C58.9262 47.7822 58.3682 47.2241 58.3682 46.5386V40.3207C58.3682 39.6352 58.9262 39.0772 59.6118 39.0772C60.2973 39.0772 60.8554 39.6352 60.8554 40.3207V46.5386Z"
        fill="#C99100"
      />
    </svg>
  )
}

export default ModalMessageWarningIcon
